import { type ComponentPropsWithRef, forwardRef, memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const fieldText = tailwindVariants({
  base: 'absolute top-full flex w-full translate-y-1 items-center gap-1 text-12',
  defaultVariants: {
    color: 'red',
  },
  variants: {
    color: {
      green: 'ads:text-success text-green-9',
      grey: 'ads:text-metadata text-gray-10',
      red: 'ads:text-error text-red-9',
    },
  },
});

export type FieldTextVariants = VariantProps<typeof fieldText>;

export type FieldTextProps = Omit<ComponentPropsWithRef<'div'>, 'color'> & FieldTextVariants;

export const FieldText = memo(
  forwardRef<HTMLDivElement, FieldTextProps>(({ children, className, color, ...restOfProps }, forwardedRef) => {
    return (
      <div
        className={fieldText({ className, color })}
        data-color={color}
        data-testid="FIELD_TEXT"
        ref={forwardedRef}
        {...restOfProps}
      >
        {children}
      </div>
    );
  }),
);

FieldText.displayName = 'FieldText';
